import Chart from "react-apexcharts";

// Options are built as plain object literals across the app, which don't
// narrow to ApexOptions' string unions, so keep the props loosely typed.
type BarChartProps = {
  chartData: any[];
  chartOptions: any;
};

// Props flow straight through so the chart re-renders on theme/language changes.
const BarChart = ({ chartData, chartOptions }: BarChartProps) => (
  <Chart
    options={chartOptions}
    series={chartData}
    type="bar"
    width="100%"
    height="100%"
  />
);

export default BarChart;
